import { sliderClasses } from '@mui/material/Slider';
// ----------------------------------------------------------------------
export function slider(theme) {
    var _a;
    var lightMode = theme.palette.mode === 'light';
    return {
        MuiSlider: {
            styleOverrides: {
                root: (_a = {},
                    _a["&.".concat(sliderClasses.disabled)] = {
                        color: theme.palette.action.disabled
                    },
                    _a),
                rail: {
                    opacity: 0.32
                },
                markLabel: {
                    fontSize: 13,
                    color: theme.palette.text.disabled
                },
                valueLabel: {
                    borderRadius: 8,
                    backgroundColor: theme.palette.grey[lightMode ? 800 : 700]
                }
            }
        }
    };
}
